export const commentWall = [
  {
    id: "w1",
    user: "夜猫子小周",
    level: "资深吃瓜",
    time: "12分钟前",
    content:
      "秒删这条我全程在场。真的就是两分钟，截图保存框都还没弹出来就没了，这手速建议去参加电竞。",
    likes: 1286,
    topicId: "topliu-shanye-shanwen",
    topicTitle: "顶流深夜发文又秒删",
    replies: 42,
  },
  {
    id: "w2",
    user: "理性吃瓜党",
    level: "观点输出",
    time: "26分钟前",
    content:
      "换角这事别急着站队，等开机照出来再说。现在这三种说法，说实话哪一种都拿不出完整证据链。",
    likes: 964,
    topicId: "guzhuang-huanjiao-fengbo",
    topicTitle: "古装大剧换角风波",
    replies: 87,
  },
  {
    id: "w3",
    user: "凌晨三点的键盘",
    level: "热聊常客",
    time: "40分钟前",
    content:
      "直播间话术的边界真的该立个规矩了。「不影响使用」这四个字我今年已经听了不下十遍。",
    likes: 872,
    topicId: "daidai-zhubo-fanche",
    topicTitle: "带货主播直播间翻车",
    replies: 63,
  },
  {
    id: "w4",
    user: "追完就跑",
    level: "资深吃瓜",
    time: "1小时前",
    content:
      "音乐节那个大合唱是真的。前一秒还在骂，副歌一响全场立刻和解，人类真的很奇怪又很可爱。",
    likes: 745,
    topicId: "yinyuejie-yazhou-chidao",
    topicTitle: "音乐节压轴歌手迟到",
    replies: 29,
  },
  {
    id: "w5",
    user: "工位潜水员",
    level: "围观群众",
    time: "2小时前",
    content:
      "工程机低温铰链那个我看了原视频，异响其实挺轻微的。但品牌方那句「正常物理特性」，属于把用户当外行。",
    likes: 688,
    topicId: "zhedie-ping-liangchan",
    topicTitle: "折叠屏被曝量产问题",
    replies: 51,
  },
  {
    id: "w6",
    user: "只看不吵",
    level: "观点输出",
    time: "3小时前",
    content:
      "真人秀剪辑这个讨论最有价值。我们看的「真实」本来就是被剪过的，能意识到这一点，比争谁的镜头多更有意义。",
    likes: 1320,
    topicId: "zhenrenxiu-jianji-zhengyi",
    topicTitle: "真人秀剪辑争议升级",
    replies: 74,
  },
  {
    id: "w7",
    user: "八年前的观众",
    level: "热聊常客",
    time: "5小时前",
    content:
      "重组这条看哭了。当年没抢到票，这次提前定好闹钟，结果还是三分钟没了，人生重演。",
    likes: 1105,
    topicId: "laopai-yuedui-chongzu",
    topicTitle: "老牌乐队宣布重组",
    replies: 38,
  },
  {
    id: "w8",
    user: "排队恐惧症",
    level: "围观群众",
    time: "7小时前",
    content:
      "三小时换一顿饭这件事，我的答案是：如果好吃到能记住三个月，那就值；如果只是「还行」，那就是给短视频交学费。",
    likes: 596,
    topicId: "wanghong-canting-paigzu",
    topicTitle: "网红餐厅排队三小时",
    replies: 22,
  },
];

export const topicComments: Record<
  string,
  { id: string; user: string; level: string; time: string; content: string; likes: number }[]
> = {
  "topliu-shanye-shanwen": [
    {
      id: "c1-1",
      user: "凌晨蹲守",
      level: "资深吃瓜",
      time: "1小时前",
      content:
        "我截到了那条动态的截图，七个字里有两个是标点，真正有信息量的就五个字。但就是这五个字能衍生出八百种解读，网友的想象力真不是盖的。",
      likes: 862,
    },
    {
      id: "c1-2",
      user: "不爱阴谋论",
      level: "观点输出",
      time: "2小时前",
      content:
        "「误操作」这个说法本身没问题，问题在于声明发得太快了。凌晨三点，两小时内成稿、审核、发布，这个效率对一个日常更新都慢的工作室来说，挺反常的。",
      likes: 739,
    },
    {
      id: "c1-3",
      user: "路人甲乙丙",
      level: "围观群众",
      time: "3小时前",
      content: "建议大家先睡，这种瓜通常第二天上午才落地。深夜发的都是引子，白天才是正文。",
      likes: 611,
    },
    {
      id: "c1-4",
      user: "数据考古学家",
      level: "热聊常客",
      time: "4小时前",
      content:
        "翻了他近一年的发文记录，深夜零点到三点这个区间总共只有四次，其中两次都跟合作相关。所以时间点确实值得留意。",
      likes: 528,
    },
  ],
  "guzhuang-huanjiao-fengbo": [
    {
      id: "c2-1",
      user: "原著十九遍",
      level: "资深吃瓜",
      time: "3小时前",
      content:
        "作为原著粉我其实松了一口气。这个男主的性格弧线很难演，如果不是特别契合的演员，换了未必是坏事。问题只是官方的说法太含糊。",
      likes: 704,
    },
    {
      id: "c2-2",
      user: "剧组扫地僧",
      level: "观点输出",
      time: "4小时前",
      content:
        "「档期调整」是行业里最常见的一个通用说法，很多时候它只是不想说真话的代名词。真正的原因通常要等到某方过几年在采访里随口提起才会浮出来。",
      likes: 621,
    },
    {
      id: "c2-3",
      user: "开机倒计时",
      level: "热聊常客",
      time: "5小时前",
      content: "离三周就开机，接替的演员连剧本围读时间都不够。我现在更担心成片质量，而不是谁演。",
      likes: 487,
    },
  ],
  "lianzong-jiabin-xueli": [
    {
      id: "c3-1",
      user: "恋综观察五年",
      level: "资深吃瓜",
      time: "6小时前",
      content:
        "素人上恋综本质上是一次素人身份的「出道」。既然要吃这波流量，被审视是必然的。但审视也该有边界，不应该是无差别扒隐私。",
      likes: 655,
    },
    {
      id: "c3-2",
      user: "冷静一点",
      level: "观点输出",
      time: "7小时前",
      content:
        "关键是节目组有没有做背景核实。如果做了却出现出入，那是嘉宾的问题；如果没做，那节目组的责任更大。现在什么都不说，两边都难逃。",
      likes: 589,
    },
    {
      id: "c3-3",
      user: "随便看看",
      level: "围观群众",
      time: "9小时前",
      content: "说实话我更想看节目组怎么回应，这比嘉宾学历本身有意思多了。",
      likes: 342,
    },
  ],
  "daidai-zhubo-fanche": [
    {
      id: "c4-1",
      user: "退款中",
      level: "热聊常客",
      time: "5小时前",
      content:
        "我买了其中一款。包装差异是真的，但更让我不适的是讲解时那句「和专柜一模一样」。这句话现在回看，每个字都值得推敲。",
      likes: 812,
    },
    {
      id: "c4-2",
      user: "电商老运营",
      level: "观点输出",
      time: "8小时前",
      content:
        "直播话术里「同款」「同源」「同规格」这几个词，法律含义差别很大，但主播念出来的时候语气是一样的。这就是争议的根源。",
      likes: 776,
    },
    {
      id: "c4-3",
      user: "路人转粉又转黑",
      level: "围观群众",
      time: "10小时前",
      content: "两套处理方案听着挺客气，但核心规格差异一句没提。这种回应就是在等热度自己降下去。",
      likes: 534,
    },
    {
      id: "c4-4",
      user: "钱包守卫",
      level: "资深吃瓜",
      time: "12小时前",
      content: "建议以后直播间下单前先截图保存讲解画面，这才是最有效的自我保护。",
      likes: 468,
    },
  ],
  "yinyuejie-yazhou-chidao": [
    {
      id: "c5-1",
      user: "站桩六小时",
      level: "资深吃瓜",
      time: "12小时前",
      content:
        "我在第一排。等的那四十分钟其实大家还挺克制的，真正开始骂是因为大屏一直在放广告，那个才是情绪引爆点。",
      likes: 698,
    },
    {
      id: "c5-2",
      user: "听了十年现场",
      level: "观点输出",
      time: "15小时前",
      content:
        "音乐节的换场时间是按分钟算的，超时会影响后面所有环节。这次是压轴所以影响有限，但如果发生在中间，性质就不一样了。",
      likes: 604,
    },
    {
      id: "c5-3",
      user: "第二天嗓子哑了",
      level: "围观群众",
      time: "16小时前",
      content: "说实话开唱之后真的什么都忘了。这就是现场音乐最不讲道理也最迷人的地方。",
      likes: 455,
    },
  ],
  "dianjing-caifang-yanlun": [
    {
      id: "c6-1",
      user: "十年老观众",
      level: "观点输出",
      time: "15小时前",
      content:
        "职业选手在采访里说真话是好事，但「点名队友」和「指出团队问题」是两码事。前者解决不了任何问题，只会让更衣室更难进人。",
      likes: 731,
    },
    {
      id: "c6-2",
      user: "赛后复盘党",
      level: "资深吃瓜",
      time: "16小时前",
      content:
        "从比赛录像看，他说的那个决策失误确实存在。所以争议不在于「说得对不对」，而在于「该不该公开说」。",
      likes: 617,
    },
    {
      id: "c6-3",
      user: "只打排位",
      level: "围观群众",
      time: "18小时前",
      content: "俱乐部这个回应等于没回应。不过说实话，这种时候说什么都会被解读，沉默可能是最优解。",
      likes: 398,
    },
  ],
  "zhedie-ping-liangchan": [
    {
      id: "c7-1",
      user: "数码老白",
      level: "观点输出",
      time: "18小时前",
      content:
        "低温铰链阻力变大在材料学上确实存在，但「用户能不能接受」和「技术是否合理」是两个层面。官方把技术解释当成了情绪安抚，这是错的。",
      likes: 689,
    },
    {
      id: "c7-2",
      user: "等等党永不为奴",
      level: "资深吃瓜",
      time: "19小时前",
      content: "反正我从来不买第一代。这次的讨论又验证了一次：新品类第一代，永远是花钱帮厂商做测试。",
      likes: 573,
    },
    {
      id: "c7-3",
      user: "参数党",
      level: "围观群众",
      time: "21小时前",
      content: "更想看零售机的第三方拆解，工程机的问题不一定代表量产机，但官方的解释也确实有点快。",
      likes: 421,
    },
  ],
  "wanghong-canting-paigzu": [
    {
      id: "c8-1",
      user: "探店三十家",
      level: "观点输出",
      time: "20小时前",
      content:
        "排三小时的店我基本不去。不是因为不好吃，是因为人在饥饿和疲惫状态下，对味道的判断本身就会失真，你会不自觉地给等待找一个理由。",
      likes: 634,
    },
    {
      id: "c8-2",
      user: "本地人",
      level: "热聊常客",
      time: "22小时前",
      content:
        "这家开在我家楼下，以前工作日中午随便进。现在想吃只能下午两点之后去碰运气。对附近居民来说，这波流量真的一言难尽。",
      likes: 590,
    },
    {
      id: "c8-3",
      user: "干饭不排队",
      level: "围观群众",
      time: "1天前",
      content: "店主说不扩产这点我挺尊重的。至少人家没想着趁热度收割一波就跑。",
      likes: 377,
    },
  ],
  "zhenrenxiu-jianji-zhengyi": [
    {
      id: "c9-1",
      user: "逐帧看综艺",
      level: "资深吃瓜",
      time: "1天前",
      content:
        "预告把那段剪进重点位置，正片却完全没有，这个落差才是争议的起点。如果预告里不放，可能根本不会有今天这一出。",
      likes: 702,
    },
    {
      id: "c9-2",
      user: "剪辑从业者",
      level: "观点输出",
      time: "1天前",
      content:
        "真人秀的成片比大概是几十比一，必然有大量素材不会出现。问题不在删减本身，而在于预告和正片的逻辑是否自洽。这次确实不自洽。",
      likes: 655,
    },
    {
      id: "c9-3",
      user: "路人观众",
      level: "围观群众",
      time: "1天前",
      content: "说实话这个讨论比节目本身好看。我现在看综艺都带一点「剪辑考古」的心态了。",
      likes: 409,
    },
  ],
  "laopai-yuedui-chongzu": [
    {
      id: "c10-1",
      user: "八年前的观众",
      level: "热聊常客",
      time: "1天前",
      content: "当年解散那场演出我没去成，这次说什么也要补上。抢到票的那一刻手是抖的。",
      likes: 815,
    },
    {
      id: "c10-2",
      user: "只听专辑",
      level: "观点输出",
      time: "1天前",
      content:
        "情怀值钱，但不能只靠情怀。我更期待他们发一首新歌，用作品证明这次重组不只是怀旧巡演。",
      likes: 627,
    },
    {
      id: "c10-3",
      user: "二手票受害者",
      level: "围观群众",
      time: "2天前",
      content: "三分钟售罄是真的，但二手平台的价格已经离谱了。希望主办方后面能加场，不然又是一场拼手速的悲剧。",
      likes: 512,
    },
  ],
};